import { render, staticRenderFns } from "./CheckPersonGotRoles.vue?vue&type=template&id=10cf91da"
import script from "./CheckPersonGotRoles.vue?vue&type=script&lang=js"
export * from "./CheckPersonGotRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports